import type { ModifyCustomerNoteResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../../../services/api';
import { queryKeys } from '../../../../../../services/query-key/query-keys';

type ModifyCustomerNoteVariables = {
  noteId: string;
  customerId: string;
  content: string;
};

export function useModifyCustomerNote(
  options?: UseMutationOptions<ModifyCustomerNoteResponse, unknown, ModifyCustomerNoteVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ noteId, content }) => {
      const api = getPrivateApi();

      return api.modifyCustomerNote({
        noteId,
        modifyCustomerNoteRequest: { content },
      });
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(queryKeys.customerNotes(variables.customerId));

        await options?.onSuccess?.(data, variables, context);
      },
    },
  );
}
